import {
  IServicePricingCreateDTO,
  IServicePricingDiscountDTO,
  IServicePricingModel,
  IServicePricingResponseDTO,
  IServicePricingUpdateDTO,
  IServicePricingUpdatePayload
} from '../types/service-pricing'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class ServicePricingService {
  public async fetchPricing(serviceId: string, orgId: string): Promise<IServicePricingModel | null> {
    const result = await serverApi.post<IServicePricingModel | null>(Paths.servicePricing.getByServiceIdOrgId, {
      serviceId,
      orgId
    })
    return result.data
  }

  public async createPricing(pricing: IServicePricingCreateDTO): Promise<IServicePricingResponseDTO> {
    const result = await serverApi.post<IServicePricingResponseDTO>(Paths.servicePricingBaseUrl, pricing)
    return result.data
  }

  public async updatePricing(pricing: IServicePricingUpdateDTO): Promise<IServicePricingResponseDTO> {
    const result = await serverApi.put<IServicePricingResponseDTO>(Paths.servicePricingBaseUrl, pricing)
    return result.data
  }

  public async getServicePricingDiscount(serviceId: string): Promise<IServicePricingDiscountDTO> {
    const result = await serverApi.get<IServicePricingDiscountDTO>(
      `${Paths.servicePricingBaseUrl}/${serviceId}/discounts`
    )
    return result.data
  }

  public async generateDefaultServicePricingDiscount(serviceId: string): Promise<IServicePricingDiscountDTO> {
    const result = await serverApi.post<IServicePricingDiscountDTO>(
      `${Paths.servicePricingBaseUrl}/${serviceId}/discounts`
    )
    return result.data
  }

  public async updateServicePricingDiscount(
    serviceId: string,
    payload: IServicePricingUpdatePayload
  ): Promise<IServicePricingDiscountDTO> {
    const result = await serverApi.put<IServicePricingDiscountDTO>(
      `${Paths.servicePricingBaseUrl}/${serviceId}/discounts`,
      payload
    )
    return result.data
  }
}

const servicePricingService = new ServicePricingService()
export { servicePricingService }



// WEBPACK FOOTER //
// ./src/services/ServicePricing.ts